/** Clear cached assets and load the latest production bundle. */
export async function applyAppUpdate(): Promise<void> {
  if ('serviceWorker' in navigator) {
    const regs = await navigator.serviceWorker.getRegistrations();
    await Promise.all(regs.map((r) => r.unregister()));
  }
  if ('caches' in window) {
    const keys = await caches.keys();
    await Promise.all(keys.map((k) => caches.delete(k)));
  }
  const url = new URL(window.location.href);
  url.searchParams.set('__v', String(Date.now()));
  window.location.replace(url.toString());
}

export function isProductionUpdateChecksEnabled(): boolean {
  return import.meta.env.PROD && import.meta.env.VITE_APP_ENV === 'production';
}
